'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = {
  className: _react.PropTypes.string
};

var ModalBody = function ModalBody(props) {
  var classes = (0, _classnames2.default)(props.className, 'modal-body');

  return _react2.default.createElement('div', _extends({}, props, { className: classes }));
};

ModalBody.propTypes = propTypes;

exports.default = ModalBody;


/*****************
 ** WEBPACK FOOTER
 ** ./~/reactstrap/lib/ModalBody.js
 ** module id = 183
 ** module chunks = 0
 **/